export default function useJakhubMenuHeight() {
    setTimeout(() => {
        const menuBox = document.getElementById('jakhub-menu-header')?.getBoundingClientRect();
        document.documentElement.style.setProperty(
            '--jakhubMenuHeaderHeight',
            `${menuBox?.height}px`
        );

        const filtersBox = document
            .getElementById('jakhub-search-filters')
            ?.getBoundingClientRect();
        document.documentElement.style.setProperty(
            '--jakhubSearchFiltersHeight',
            `${filtersBox?.height}px`
        );

        const footerBox = document.getElementById('jakhub-footer')?.getBoundingClientRect();
        document.documentElement.style.setProperty('--jakhubFooterYPos', `${footerBox?.top}px`);
    }, 0);
}
